import {
  Autocomplete,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material'
import React from 'react'
import styles from 'components/DueDiligence/Questions/QuestionComponents/styles'
import {
  ADDRESS_PROOF_THIRD_PARTY_TYPES,
  DEFAULT_ADDRESS_PROOF_THIRD_PARTY_TYPE,
  TRANSLATED_ADDRESS_PROOF_THIRD_PARTY_TYPES,
} from 'utils/constants/addressOcr'

const AddressOcrNameForm = ({ ocrData, formState, updateFormState, formErrors }) => {
  const classes = styles()

  const onChangeRadionButton = (radioValue) => {
    const isOnPersonName = radioValue === 'yes'
    const updateData = { is_address_proof_on_person_name: isOnPersonName }

    if (isOnPersonName) {
      updateData.third_party_name_on_address_proof = null
      updateData.third_party_relation_on_address_proof = null
    }
    else {
      updateData.third_party_relation_on_address_proof = updateData.third_party_relation_on_address_proof || DEFAULT_ADDRESS_PROOF_THIRD_PARTY_TYPE 
    }

    const newData = {
      ...formState,
      ...updateData,
    }
    updateFormState(newData)
  }
  
  const isAddressProofOnPersonName = () => (formState.is_address_proof_on_person_name == null ? true : formState.is_address_proof_on_person_name)
  return (
    <React.Fragment>
      {!ocrData?.continued_without_validation && (
        <FormControl className={classes.radioQuestion}>
          <FormLabel id="thirdPartyProofOfAddress">
            O comprovante de residência está em seu nome?
          </FormLabel>
          <RadioGroup
            row
            value={isAddressProofOnPersonName() ? 'yes' : 'no'}
            name="thirdPartyProofOfAddress"
            onChange={(event) => onChangeRadionButton(event.target.value)}
          >
            <FormControlLabel value="yes" control={<Radio />} label="Sim" />
            <FormControlLabel
              value="no"
              control={<Radio />}
              label="Não, o comprovante refere-se a outra pessoa"
            />
          </RadioGroup>
        </FormControl>
      )}

      {!isAddressProofOnPersonName() && (
        <FormControl className={classes.radioQuestion}>
          <FormLabel id="thirdPartyNameOnAddressProofLabel">
            A quem se refere o comprovante?
          </FormLabel>
          <div style={{ display: 'flex', gap: 5, margin: '8px 0' }}>
            <TextField
              placeholder="Nome"
              label="Nome"
              error={formErrors?.third_party_name_on_address_proof || formErrors?.third_party_relation_on_address_proof}
              fullWidth
              value={formState.third_party_name_on_address_proof || ''}
              name="thirdPartyNameOnAddressProof"
              onChange={(event) =>
                updateFormState({
                  ...formState,
                  third_party_name_on_address_proof: event.target.value,
                })
              }
            />
            <Autocomplete
              disablePortal
              options={Object.values(ADDRESS_PROOF_THIRD_PARTY_TYPES)}
              getOptionLabel={(option) => TRANSLATED_ADDRESS_PROOF_THIRD_PARTY_TYPES[option]}
              value={
                formState.third_party_relation_on_address_proof ||
                DEFAULT_ADDRESS_PROOF_THIRD_PARTY_TYPE
              }
              sx={{ width: 300 }}
              onChange={(_event, new_value) =>
                updateFormState({
                  ...formState,
                  third_party_relation_on_address_proof: new_value,
                })
              }
              renderInput={(params) => <TextField {...params} label="Relação" />}
            />
          </div>
        </FormControl>
      )}
    </React.Fragment>
  )
}

export default AddressOcrNameForm
